import { Component, OnInit, Input } from '@angular/core';
import { ObservacaoEstudo } from './observacao-estudo';
import { ObservacaoEstudoService } from './observacao-estudo.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-observacao-estudo',
  templateUrl: './observacao-estudo.component.html',
  styleUrls: ['./observacao-estudo.component.css']
})
export class ObservacaoEstudoComponent implements OnInit {

  @Input()  idEstudo: number;

  public observacao: ObservacaoEstudo;
  public isLoading: boolean;

  constructor(
    private mensagem: MatSnackBar,
    private observacaoService: ObservacaoEstudoService
  ) {}

  ngOnInit() {
    this.isLoading = true;  
    this.observacao = new ObservacaoEstudo();
    this.observacao.codigoEstudoSocioEconomico = this.idEstudo;

    this.observacaoService.filtrar(this.observacao).subscribe(
      (result: ObservacaoEstudo[]) => {
        if(result && result.length > 0){
          this.observacao = result[0];
        }
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  public salvar() {
    this.isLoading = true;
    this.observacaoService.update(this.observacao).subscribe(
      result => {
        this.mensagem.open('Observação salva com sucesso!', 'X', {
          duration: 5000
        });
        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  private erro(erro: string): void {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }
}
